import React from 'react';
import { useTranslation } from 'react-i18next';
import VerifiedBadge from '../../UI/VerifiedBadge';
import LinkedAccounts from '../LinkedAccounts';

export default function EditProfileSidebar({
  user,
  phone,
  profileState,
  profileCity,
  companyName,
  languages,
  verificationContent,
}) {
  const { t } = useTranslation();
  return (
    <div className="epSidebar">
      <div className="epCard epCardVerification">
        <h2 className="epCardTitle">
          <VerifiedBadge size={20} />
          {t('profile.verificationBadge')}
        </h2>
        {verificationContent}
      </div>
      <div className="epCard epCardInfo">
        <h3 className="epCardSubtitle">{t('profile.accountInfo')}</h3>
        <div className="epInfoRow">
          <span className="epInfoLabel">{t('auth.email')}</span>
          <span className="epInfoValue">{user?.email || '—'}</span>
        </div>
        <div className="epInfoRow">
          <span className="epInfoLabel">{t('profile.phone')}</span>
          <span className="epInfoValue">{phone || '—'}</span>
        </div>
        <div className="epInfoRow">
          <span className="epInfoLabel">{t('profile.location')}</span>
          <span className="epInfoValue">
            {profileCity && profileState ? `${profileCity}, ${profileState}` : profileState || '—'}
          </span>
        </div>
        {companyName && (
          <div className="epInfoRow">
            <span className="epInfoLabel">{t('profile.business')}</span>
            <span className="epInfoValue">{companyName}</span>
          </div>
        )}
        {languages && (
          <div className="epInfoRow">
            <span className="epInfoLabel">{t('profile.languages')}</span>
            <span className="epInfoValue">{languages}</span>
          </div>
        )}
        <div className="epInfoRow">
          <span className="epInfoLabel">{t('profile.memberSince')}</span>
          <span className="epInfoValue">
            {user?.metadata?.creationTime
              ? new Date(user.metadata.creationTime).toLocaleDateString('de-DE', { month: 'short', year: 'numeric' })
              : '—'}
          </span>
        </div>
        <div className="epInfoRow">
          <span className="epInfoLabel">{t('profile.userId')}</span>
          <span className="epInfoValue epInfoMono">{user?.uid ? user.uid.slice(0, 12) + '...' : '—'}</span>
        </div>
      </div>
      <div className="epCard">
        <LinkedAccounts />
      </div>
    </div>
  );
}
